import Vue from 'vue';
import { isTokenExpired, getToken, destroyToken } from '@/services/jwt.service';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'DashboardPage' },
    component: () => import(/* webpackChunkName: "home" */'../views/home/home.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'DashboardPage',
        component: () => import(/* webpackChunkName: "dashboard" */'../views/dashboard/dashboard.vue'),
      },
      {
        path: 'health-status',
        name: 'HealthStatusPage',
        component: () => import(/* webpackChunkName: "health-status-page" */'../views/health-status/health-status.vue'),
      },
      {
        path: 'learning',
        name: 'LearningPage',
        component: () => import(/* webpackChunkName: "learning-page" */'../views/learning/learning.vue'),
      },
      {
        path: 'risk-status',
        name: 'RiskStatusPage',
        component: () => import(/* webpackChunkName: "risk-status-page" */'../views/risk-status/risk-status.vue'),
      },
      {
        path: 'update-health-status',
        name: 'UpdateHealthStatusPage',
        component: () => import(/* webpackChunkName: "update-health-status-page" */'../views/update-health-status/update-health-status.vue'),
      },
    ],
  },
  {
    path: '/organization-selector',
    name: 'OrganizationSelector',
    component: () => import(/* webpackChunkName: "organization-selector" */'../views/organization-selector/organization-selector.vue'),
  },
  {
    path: '/legal-agreement',
    name: 'LegalAgreement',
    component: () => import(/* webpackChunkName: "legal-agreement" */'../views/legal-agreement/legal-agreement.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */'../views/login/login.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgot-password" */'../views/forgot-password/forgot-password.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (getToken() && !isTokenExpired()) {
    if (to.name === 'Login') {
      next({ name: 'Home' });
    } else if (to.name === 'LegalAgreement' && from.name === null) {
      // The above checks if you've refreshed the page and are on legal agreement. If you did, let's just push it back to the org selector.
      // two of things will happen. A, you have only 1 organization so it'll push you back here. B) you just have to reselect the organization. This a best case scenario rather than
      // refactoring of how each routerBefore gets handled imo.
      next({ name: 'OrganizationSelector' });
    } else {
      next();
    }
  } else {
    const permittedRoutes = [
      'Login',
      'ForgotPassword',
    ];
    if (permittedRoutes.includes(to.name)) {
      next();
    } else {
      destroyToken();
      next({ name: 'Login' });
    }
  }
  next();
});

export default router;
